import React from "react";

class LoadingImage extends React.Component{

    render() {
        return (
            <div id="loadingImg" className="text-center"><img
                src="/img/loading3.gif" alt="loading"/></div>
        )
    }
}

export default LoadingImage;